module.exports = __webpack_public_path__ + "static/media/m3pwhite.80393323.png";